import { render, staticRenderFns } from "./registrationInstall.vue?vue&type=template&id=74ee903f&scoped=true"
import script from "./registrationInstall.vue?vue&type=script&lang=js"
export * from "./registrationInstall.vue?vue&type=script&lang=js"
import style0 from "./registrationInstall.vue?vue&type=style&index=0&id=74ee903f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee903f",
  null
  
)

export default component.exports